module.exports = __webpack_public_path__ + "img/17.13d72925.jpg";